<template>
  <CustomPage title="支付成功" :orderCenter="$route.query.backRoute">
    <div slot="content" class="content">
      <div class="imgArea">
        <Empty
          :image="require('@/assets/order/payComplete.png')"
          description="订单支付成功"
        />
      </div>
      <div class="contantArea">
        <Cell title="订单流水号" :value="serialNo" />
        <Cell title="订单金额" :value="payAmount" />
      </div>
      <!-- 有抽奖资格才显示 -->
      <div class="bannerArea" v-if="isShowLotteryImage">
        <img
          :src="require('@/assets/order/lotteryGoodGiftBanner.png')"
          alt=""
          @click="jumpToHomeLotteryPlace"
        />
      </div>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { Empty, Cell } from "vant";
import { getOverlayCount } from "@/api/lotteryPlace";

export default {
  components: { CustomPage, Empty, Cell },
  data() {
    return {
      serialNo: null,
      payAmount: null,
      isShowLotteryImage: false,
    };
  },
  created() {
    const data = JSON.parse(localStorage.getItem("orderPayCompleteInfo"));
    this.serialNo = data.serialNo;
    this.payAmount = data.payAmount;

    getOverlayCount()
      //获得抽奖资格次数,大于0 才有资格
      .then(({ data }) => {
        console.log(data);

        if (data > 0) {
          this.isShowLotteryImage = true;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },

  methods: {
    // jumpToHomeLotteryPlace() {
    //   getOverlayCount()
    //     //获得抽奖资格次数,大于0 才有资格
    //     .then(({ data }) => {
    //       console.log(data);

    //       if (data > 0) {
    //         this.$router.replace({
    //           path: "/",
    //           query: { backRoute: "lottery" },
    //         });
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    jumpToHomeLotteryPlace() {
      this.$router.replace({
        path: "/",
        query: { backRoute: "lottery" },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  .contantArea {
    /deep/ .van-cell {
      justify-content: space-between;
      .van-cell__title,
      .van-cell__value {
        flex: none;
        -webkit-flex: none;
      }
    }
  }
  .bannerArea {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
